import { registerPlugin } from '@capacitor/core';

const UnifiedPush = registerPlugin('UnifiedPush');

export default UnifiedPush;